<template>
	<v-container fluid>
		<v-row	
			justify = "center"
		>
			<v-col 
				xl   = "8"
				lg   = "8"
				md   = "11"
				sm   = "11"
				xs   = "12"
				cols = "12"
			>
				
				<v-card outlined>
					<v-card-title
						class = "justify-center body-1 secondary pa-1 white--text"
					>
					
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					
					<v-spacer></v-spacer>
						
					<v-icon 
						 
						color = "primary"
						class = "mr-2"

					>
						mdi-video-plus
					</v-icon>
					<span>
						{{ $ml.get(type_device) }}
					</span>
					
					<v-spacer></v-spacer>

						
					<!-- <v-btn			
						x-small				
						outlined
						icon				
						
						class="mr-2 error"

						@click="actions('close_modal')"
					>
						<v-icon 
							x-small 
							color="white"
							
							outlined
						>mdi-close</v-icon>
					</v-btn> -->
					</v-card-title>
					<v-card-text
						class="pb-1"
					>
						<v-row >
							<v-col
								:xl="6"
								:lg="6"
								:md="6"
								:sm="6"
								:xs="12"
								:cols="12"

							>
							<!-- info_to_stream.id_stream -->
								<div style="aspect-ratio: 16 / 9; width: 100%; overflow: hidden;">
									<cam_test
										:id_stream  = "'new_device'"
										:hostname 	= "$ml.get('new_device')"
									></cam_test>
								</div>
							</v-col>
							<v-col 
								:xl 	= "6"
								:lg 	= "6"
								:md 	= "6"
								:sm 	= "6"
								:xs 	= "12"
								:cols 	= "12"
								
							>
								<v-divider></v-divider>
								<v-toolbar
						    		
						    		dense
						    		height = "25"
						    		class  = "secondary white--text"
						    	>
						    		<v-toolbar-title 
						    			class = "body-2"
						    		>
						    			{{ $ml.get('discovered_devices') }}
						    		</v-toolbar-title>
						    	</v-toolbar>
								<v-text-field
									dense
									outlined
									hide-details
									class = "mt-2 mb-2"
									:label = "$ml.get('search')"
									v-model = "search_discover"
								></v-text-field>
								<v-data-table
									dense
								    fixed-body
								    fixed-header
									:headers  			 = "header_table"
									:items 				 = "render_list"
									class 				 = "elevation-5"
									:options.sync 		 = "options"
								   	:server-items-length ="total"
									:search 			 = "search_discover"
								   	:footer-props 		 = "{
								   		showFirstLastPage 	: true,
								   		itemsPerPageOptions : [15, 30],
								   		showCurrentPage 	: true,
								   		itemsPerPageText 	: ''
								   	}"
								   	:loading-text 		 = "$ml.get('loading_please_wait')"				   	
								   	:loading 			 = "loading_discover"
								    item-key 			 = "index"
								    :height 			 = "layout_height + 'px'"
								>
								    <!-- rowsPerPageText: [30] -->
									<template v-slot:item.actions="{ item }">
										<v-tooltip bottom>
											<template v-slot:activator = "{ on, attrs }">
												<v-btn
													x-small
													color  = "success"
													@click = "actions('connect_onvif', item)"
													v-bind = "attrs"
													v-on   = "on"
												>
													<v-icon
														x-small
														v-text = "'mdi-plus'"
													></v-icon>
												</v-btn>
											</template>
											<span>{{ $ml.get('connect') }}</span>
										</v-tooltip>
									</template>
								</v-data-table>
							</v-col>
							<v-col 
								:xl 	= "12"
								:lg 	= "12"
								:md 	= "12"
								:sm 	= "12"
								:xs 	= "12"
								:cols 	= "12"								
							>
							
								<input_fields
									key 				= "fields_category"
									:input_info 		= "inf.input_info"
									:action_info 		= "action_to_field.action"
									:set_info 			= "action_to_field.info"
									@recive_info_field  = "recive_info($event, 'field')"
									@checking_rtsp 		= "disabled_register = $event"
								></input_fields>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>

						<v-btn		
							x-small				
							v-text 		= "$ml.get('register')"	
							@click 		= "actions('save')"
							color 		= "primary"
							:disabled 	= "disabled_register"
							v-show 		= "!loading_register"
						></v-btn>
						<!-- <v-btn
						

							@click = "test"
						>
							test
						</v-btn> -->
						<v-progress-linear
					      	indeterminate
							v-show = "loading_register"
					      	color  = "primary"
						></v-progress-linear>

						<v-spacer></v-spacer>
					</v-card-actions>
					<v-dialog 
						v-model = "dialog_connection" 
						width   = "500"
					>
						<v-card 
							outlined
						>
							<v-card-title
								class = "pa-1 body-2 primary"
							>
								<span v-text = "$ml.get('connection_onvif')"></span>
								<v-spacer></v-spacer>
								<v-icon
									x-small
									color  = "error"
									v-text = "'mdi-close'"
									@click = "dialog_connection = false"
								></v-icon>
							</v-card-title>
							<v-card-text class = "pt-3">
								<v-row
									justify = "center"
									align   = "center"
									class   = "mt-1"
								>
									<template
										v-for="(item_onvif, idx_onvif) of fields_onvif"
									>										
										<v-col
											:key = "idx_onvif"
											xl 	 = "11"
											lg 	 = "11"
											md 	 = "11"
											sm 	 = "12"
											xs 	 = "12"
											cols = "12"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-model = "info_onvif[item_onvif.key]"
												:type 	= "item_onvif.type"
												:label 	= "$ml.get(item_onvif.text)"
												class 	= "pa-0"
											>
												<template v-slot:append-outer>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-icon
																small
																class="ml-1"
																color="primary"
																v-on="on"
																v-bind="attrs"
															>mdi-information-outline</v-icon>
														</template>
														<span>{{ $ml.get(item_onvif.tooltip || item_onvif.text) }}</span>
													</v-tooltip>
												</template>
											></v-text-field>

										</v-col>
									</template>
								</v-row>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn		
									x-small				
									v-text = "$ml.get('connect')"	
									@click = "actions('connection_onvif')"
									color  = "primary"
									v-show = "!loading_onvif"
								></v-btn>
								<v-btn		
									x-small				
									v-show = "!loading_onvif"
									v-text = "$ml.get('close')"	
									@click = "dialog_connection = false"
									color  = "error"
								></v-btn>
								<v-progress-linear
							      	indeterminate
									v-show = "loading_onvif"
							      	color  = "primary"
							    ></v-progress-linear>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<v-dialog 
						v-model = "dialog_profiles" 
						width   = "900"
						persistent
					>
						<v-card 
							outlined
						>
							<v-card-title
								class = "pa-2 body-2 primary white--text"
							>
								<span v-text = "$ml.get('select_profile')"></span>
								<v-spacer></v-spacer>
								<v-icon
									x-small
									color  = "white"
									v-text = "'mdi-close'"
									@click = "closeProfileDialog()"
								></v-icon>
							</v-card-title>
							<v-card-text class = "pt-3">
								<v-data-table
									dense
									fixed-header
									:headers  			 = "header_profiles_table"
									:items 				 = "profiles_list"
									class 				 = "elevation-2"
									item-key 			 = "id"
									:height 			 = "400"
									v-model 			 = "selected_profiles"
									show-select
									single-select
								>
									<template v-slot:item.main.rtsp="{ item }">
										<span class="text-truncate" style="max-width: 300px; display: inline-block;" :title="item.main && item.main.rtsp ? item.main.rtsp : ''">
											{{ item.main && item.main.rtsp ? item.main.rtsp : '-' }}
										</span>
									</template>
									<template v-slot:item.sub="{ item }">
										<span v-if="item.sub && item.sub.rtsp" class="text-truncate" style="max-width: 300px; display: inline-block;" :title="item.sub.rtsp">
											{{ item.sub.rtsp }}
										</span>
										<span v-else>-</span>
									</template>
									<template v-slot:item.hasPtz="{ item }">
										<v-icon v-if="item.hasPtz" small color="success">mdi-check</v-icon>
										<v-icon v-else small color="grey">mdi-close</v-icon>
									</template>
								</v-data-table>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn		
									x-small				
									v-text = "$ml.get('select')"	
									@click = "selectProfile()"
									color  = "primary"
									:disabled = "!selected_profiles || selected_profiles.length === 0"
								></v-btn>
								<v-btn		
									x-small				
									v-text = "$ml.get('close')"	
									@click = "closeProfileDialog()"
									color  = "error"
								></v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-card>
			</v-col>
		</v-row>	
</v-container>
</template>
<script>
	import input_fields from '@/components/info/input_fields.vue'
	import axios 		from 'axios'
	import Eventbus 	from '@/event-bus'
	import cam_test 	from '@/components/cam_test.vue'
	import { debounce } from '@/helpers/debounce.js'
	import { fetchOnvifMediaProfiles } from '../../services/onvifApi.js'
	
	export default{
		name: 'new_dev',
		components:{
			input_fields,
			cam_test
		}, // components

		props:[
			// 'type_dev',
			// 'is_open',
		],
		data: (vm) => ({
			dialog: false,
			inf: {
				input_info:[
					{
						key: 'rtsp',
						text: 'channel',
						text1 : '1',
						type: 'check',
						icon: 'mdi-video',
						icon1: 'mdi-connection',						
						icon_record : 'mdi-record-rec',
						icon_retransmission : 'mdi-video-wireless',
						tooltip: 'tooltip_rtsp',
						show : true,
						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},
						{
						key: 'rtsp2',
						text: 'channel',
						text1 : '2',
						type: 'check',
						icon: 'mdi-video',
						placeholder : vm.$ml.get('for_stream_2'),
						icon1: 'mdi-connection',
						icon_record : 'mdi-record-rec',
						icon_retransmission : 'mdi-video-wireless',						
						tooltip: 'tooltip_rtsp2',
						show : true,
						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'hls',
						text: 'stream_hls',
						text1 : '2',
						type: 'text',
						icon: 'mdi-video',						
						icon_record : 'mdi-record-rec',
						icon_retransmission : 'mdi-video-wireless',						
						tooltip: 'tooltip_hls',
						show : true,
						show_in : ["IP_CAM"],

						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},
					{
						//'name device',						
						key: 'name',
						text: 'name',
						type: 'text',
						icon: "mdi-map-marker",
						tooltip: 'tooltip_name',
						rules : [
							
								value => value && value.length >= 4 || 'Min 4 characters'
													
						],
						counter_active : true,
						show : true,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					/*{
						key: 'user',
						text:'user',
						type: 'text',
						icon: 'mdi-account',
						value : 'admin',
						show : true,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'password',
						text: 'password',
						type: 'password',
						icon: 'mdi-lock',
						value : '1234',						
						show : true,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},*/
					
					{
						key: 'is_record',
						text:'record',
						type: 'switch',
						icon: 'mdi-record-rec',
						tooltip: 'tooltip_is_record',
						value : true,
						show : true,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'limit',
						text:'limit',
						type: 'capacity',
						icon: 'mdi-file-video',
						placeholder : vm.$ml.get('mb_gb'),
						tooltip: 'tooltip_limit',
						value : 10,
						show : true,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'is_motion',
						text:'motion',
						type: 'switch',
						icon: 'mdi-image-multiple',
						tooltip: 'tooltip_is_motion',
						value : false,
						show : false,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'video_for_display',
						text:'streaming',
						type: 'switch',
						icon: 'mdi-video',
						value: true,
						placeholder : '',
						tooltip: 'tooltip_video_streaming',
						show : false,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					{
						key: 'ip_machine',
						text: 'ip_machine',
						type: 'text',
						icon: 'mdi-ip',
						value : '127.0.0.1',						
						tooltip: 'tooltip_ip_machine',
						show : false,
						cols: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					{
						key 	: 'image',
						text 	: 'image',
						type 	: 'select',
						items 	: [
							'jcaltamare/ebenezermotion:latest', 
							'jcaltamare/ebenezermotion:motion_no_avx',
							'jcaltamare/ebenezermotion:motion_arm_ubuntu_20' , 
						],						
						icon 	: 'mdi-docker',
						value 	: '127.0.0.1',						
						tooltip : 'tooltip_image',
						show 	: false,
						cols 	: {

							xl: '4',
							lg: '4',
							md: '4',
							xs: '12',
							cols: '12',
						}
					},
					// {key: 'btn',
					// 	text: 'save',
					// 	type: 'btn',
					// 	size: 'small',
					// 	icon: 'mdi-content-save',
					// 	icon_size: 'small',
					// 	icon_color: 'success',

					// 	cols:
					// 		{ 
					// 			xl: 1, 
					// 			lg: 1,
					// 			md: 1,
					// 			xs: 2,
					// 			cols: 2,
					// 			offset: 9
					// 		}	
					// },

				],
				info: {},

			},
			action_to_field: {
				action: '',
				info  : {},
			},
			// table
			header_table: [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('ip'), value: 'ip' },
				// { text: vm.$ml.get('type'), value: 'type' },
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center' },

				/*{ text: 'Name', value: 'name' },
				{ text: 'IP', value: 'ip' },
				{ text: 'action', value: 'action', align: 'center' },*/
			],
			options: { itemsPerPage: 30 },
			total: 1,
			list: [],
			layout_height: 250,
			show_list: false,
			type_device: '',
			dialog_connection: false,
			info_onvif: {},
			fields_onvif: [
				{
					key: "user",
					text: "user",
					type: "text",
					tooltip: "tooltip_onvif_user",					
				},
				{
					key: "password",
					text: "password",
					type: "password",
					tooltip: "tooltip_onvif_password",					
				},				
			],
			info_to_stream : {
				id_stream : null,
				name 	  : 'New Device',
			},
			loading_onvif 	  : false,
			loading_discover  : false,
			search_discover   : '',
			disabled_register : true,
			loading_register  : false,
			dialog_profiles   : false,
			profiles_list     : [],
			selected_profiles : [],
			rtsp2_preview_timer : null, // Timer para evitar múltiples ejecuciones
			header_profiles_table: [
				{ text: vm.$ml.get('id'), value: 'id' },
				{ text: vm.$ml.get('rtsp') || 'RTSP', value: 'main.rtsp' },
				{ text: vm.$ml.get('sub_stream') || 'SUB STREAM', value: 'sub' },
				{ text: vm.$ml.get('has_ptz') || 'PTZ', value: 'hasPtz' },
			],
			pending_body_connection: null,
			list_builder 	  : [
				'id',
				'rtsp',
				'rtsp2',
				'name',
				'deviceId',
				'user',
				'password',
				'is_record',
				'limit',
				'capacity',
				'channel_record',
				'is_motion',
				'channel_retransmission',
				'video_for_display',
				'hls',
				'ip_machine',
				'image',

			],

		}), // data
		created(){
			if (localStorage.getItem('type_Device')) {
				const type_dev = JSON.parse(localStorage.getItem('type_Device'))
				this.type_device = type_dev;
			}
			// console.log(this.check_rtsp("rtsp://Admin:ebenezer890@193.178.3.37/stream2"), 'check_rtsp')
		}, // created

		watch:{
			is_open: function(val){
				if (val) {
					this.dialog=true;
				}
			}, // is open

			options: {
				handler(){
					this.get_list();
				}, deep: true
			}, // options

			'action_to_field.info.rtsp2': {
				handler(newVal, oldVal) {
					// Limpiar timer anterior si existe
					if (this.rtsp2_preview_timer) {
						clearTimeout(this.rtsp2_preview_timer);
						this.rtsp2_preview_timer = null;
					}
					
					// Iniciar previsualización automática cuando rtsp2 tiene un valor válido
					if (newVal && newVal !== oldVal && newVal.trim() !== '' && this.check_rtsp(newVal)) {
						// Esperar un momento para evitar ejecuciones múltiples mientras se escribe
						this.rtsp2_preview_timer = setTimeout(() => {
							// Verificar nuevamente que el valor sigue siendo válido
							const currentRtsp2 = this.action_to_field.info && this.action_to_field.info.rtsp2;
							if (currentRtsp2 && this.check_rtsp(currentRtsp2)) {
								Eventbus.$emit('add_new_device', {
									rtsp     : currentRtsp2,
									deviceId : 'new_device',
									channel  : 'rtsp2' // Identificar que es el substream
								});
							}
							this.rtsp2_preview_timer = null;
						}, 500); // Delay de 500ms para evitar ejecuciones múltiples
					}
				},
				immediate: false
			}, // watch rtsp2
		}, // watch
		methods:{
			_extractProfileVideoParams(resProfiles){
				const root = resProfiles && resProfiles.data ? resProfiles.data : null;
				let profiles = [];
				if (root && root.profiles) {
					const pr = root.profiles;
					if (pr.converted && pr.converted.Body && pr.converted.Body.GetProfilesResponse && pr.converted.Body.GetProfilesResponse.Profiles) {
						profiles = pr.converted.Body.GetProfilesResponse.Profiles;
					}else if (pr.data && pr.data.GetProfilesResponse && pr.data.GetProfilesResponse.Profiles) {
						profiles = pr.data.GetProfilesResponse.Profiles;
					}else if (pr.data && pr.data.Body && pr.data.Body.GetProfilesResponse && pr.data.Body.GetProfilesResponse.Profiles) {
						profiles = pr.data.Body.GetProfilesResponse.Profiles;
					}else if (pr.GetProfilesResponse && pr.GetProfilesResponse.Profiles) {
						profiles = pr.GetProfilesResponse.Profiles;
					}else{
						const stack = [pr];
						while (stack.length) {
							const obj = stack.pop();
							if (!obj || typeof obj !== 'object') continue;
							if (obj.Profiles) {
								profiles = obj.Profiles;
								break;
							}
							Object.keys(obj).forEach(k => {
								if (obj[k] && typeof obj[k] === 'object') stack.push(obj[k]);
							});
						}
					}
				}else if (Array.isArray(root)) {
					profiles = root;
				}
				if (!profiles) profiles = [];
				if (!Array.isArray(profiles)) profiles = [profiles];

				const getDeep = (obj, pathArr) => {
					try {
						let cur = obj;
						for (let i = 0; i < pathArr.length; i++) {
							if (cur == null) return undefined;
							cur = cur[pathArr[i]];
						}
						return cur;
					} catch (e) { return undefined; }
				};
				const firstNonEmpty = (obj, paths) => {
					for (const p of paths) {
						const v = getDeep(obj, p);
						if (v !== undefined && v !== null && v !== '') return v;
					}
					return undefined;
				};

				const resultByToken = {};
				profiles.forEach(p => {
					const token = (p && p.$ && p.$.token) || p.token || p.Token || p.ProfileToken || p.id || null;
					if (!token) return;

					const encObj = firstNonEmpty(p, [
						['VideoEncoderConfiguration'],
						['tt:VideoEncoderConfiguration'],
						['video', 'encoder'],
					]) || {};

					const encoding = (firstNonEmpty(encObj, [
						['Encoding'],
						['$.Encoding'],
						['tt:Encoding'],
						['codec'],
					]) || '').toString();

					const resObj = firstNonEmpty(encObj, [
						['Resolution'],
						['tt:Resolution'],
					]) || {};
					const width  = parseInt(firstNonEmpty(resObj, [['Width'], ['tt:Width']]) || 0, 10) || 0;
					const height = parseInt(firstNonEmpty(resObj, [['Height'], ['tt:Height']]) || 0, 10) || 0;

					const rcObj = firstNonEmpty(encObj, [
						['RateControl'],
						['tt:RateControl'],
					]) || {};
					const fps     = parseInt(firstNonEmpty(rcObj, [['FrameRateLimit'], ['tt:FrameRateLimit'], ['fps']]) || 0, 10) || 0;
					const bitrate = parseInt(firstNonEmpty(rcObj, [['BitrateLimit'], ['tt:BitrateLimit'], ['bitrate']]) || 0, 10) || 0;

					resultByToken[token] = {
						encoding,
						width,
						height,
						fps,
						bitrateKbps: bitrate
					};
				});
				console.log('[ONVIF] Parsed video params by token:', resultByToken);
				return resultByToken;
			},
			_extractProfileTokens(resProfiles){
				const root = resProfiles && resProfiles.data ? resProfiles.data : null;
				let candidates = [];
				
				// Nuevo formato: { profiles: [{ id, main: { rtsp, snapshot, token }, sub: {...} }] }
				if (root && root.profiles && Array.isArray(root.profiles)) {
					// Formato nuevo - extraer directamente de profiles
					candidates = root.profiles.map(p => {
						const id = p.id || p.token || null;
						const token = (p.main && p.main.token) || id || null;
						const name = id || token || '';
						return { token, name, profile: p };
					}).filter(p => p.token);
					return candidates;
				}
				
				// Formato antiguo ONVIF
				if (root && root.profiles) {
					const pr = root.profiles;
					if (pr.converted && pr.converted.Body && pr.converted.Body.GetProfilesResponse && pr.converted.Body.GetProfilesResponse.Profiles) {
						candidates = pr.converted.Body.GetProfilesResponse.Profiles;
					}else if (pr.data && pr.data.GetProfilesResponse && pr.data.GetProfilesResponse.Profiles) {
						candidates = pr.data.GetProfilesResponse.Profiles;
					}else if (pr.data && pr.data.Body && pr.data.Body.GetProfilesResponse && pr.data.Body.GetProfilesResponse.Profiles) {
						candidates = pr.data.Body.GetProfilesResponse.Profiles;
					}else if (pr.GetProfilesResponse && pr.GetProfilesResponse.Profiles) {
						candidates = pr.GetProfilesResponse.Profiles;
					}else{
						const stack = [pr];
						while (stack.length) {
							const obj = stack.pop();
							if (!obj || typeof obj !== 'object') continue;
							if (obj.Profiles) {
								candidates = obj.Profiles;
								break;
							}
							Object.keys(obj).forEach(k => {
								if (obj[k] && typeof obj[k] === 'object') stack.push(obj[k]);
							});
						}
					}
				}else if (Array.isArray(root)) {
					candidates = root;
				}
				if (!candidates) return [];
				if (!Array.isArray(candidates)) candidates = [candidates];
				const norm = candidates.map(p => {
					const token = (p && p.$ && p.$.token) || p.token || p.Token || p.ProfileToken || p.id || null;
					const name  = (p && p.Name) || (p && p.$ && p.$.Name) || null;
					return { token, name };
				}).filter(p => p.token);
				return norm;
			},
			test(){
				Eventbus.$emit('start_installation_progress', {name:'test'});
			},
			recive_info(val, from){
				if (val.action == 'save') {
					console.log('step 4, recive');
					this.inf.info = val.value;
					this.save();
				}
			}, // recive_info
			actions(act, item){
				

				if (act == 'save' ) {
					console.log('step 1');
					this.action_to_field.action = act;
					
				}
				if (act == 'connect_onvif') { // before connect
					this.dialog_connection = true;
					this.info_onvif = item;

				}
				if (act == 'connection_onvif') { // connection
					this.loading_onvif = true;
					let msg = 'Connection Fail';
					let videoParamsByToken = {};
					let token1 = null;
					let token2 = null;

					// Construir conexión ONVIF desde item seleccionado + credenciales
					const xaddrs  = (this.info_onvif && Array.isArray(this.info_onvif.xaddrs)) ? this.info_onvif.xaddrs : [];
					const xaddr   = xaddrs.find(u => u && u.indexOf('[') === -1) || xaddrs[0] || '';
					const username = this.info_onvif && this.info_onvif.user ? this.info_onvif.user : '';
					const password = this.info_onvif && this.info_onvif.password ? this.info_onvif.password : '';
				
				// Extraer hostname del xaddr o del info_onvif
				let hostname = '';
				if (xaddr) {
					try {
						const url = new URL(xaddr);
						hostname = url.hostname;
					} catch(e) {
						// Si falla, intentar extraer del xaddr manualmente
						const match = xaddr.match(/https?:\/\/([^\/:]+)/);
						if (match) hostname = match[1];
					}
				}
				if (!hostname && this.info_onvif && this.info_onvif.hostname) {
					hostname = this.info_onvif.hostname;
				}
				if (!hostname && this.info_onvif && this.info_onvif.host) {
					hostname = this.info_onvif.host;
				}
				
				// Obtener rtsp1 y rtsp2 del formulario (solo para uso posterior, no en la conexión inicial)
				const rtsp1 = (this.inf && this.inf.info && this.inf.info.rtsp) ? this.inf.info.rtsp : '';
				const rtsp2 = (this.inf && this.inf.info && this.inf.info.rtsp2) ? this.inf.info.rtsp2 : '';
					
				const baseURL =  this.$URL; // e.g., http://localhost:9090
					
				// Construir conexión ONVIF sin rtsp1/rtsp2 para la llamada inicial de perfiles
				const bodyConnection = {
					connection : {
						xaddr    : xaddr,
						hostname : hostname,
						username : username,
						password : password,
					}
				};
					
				// Paso 1: listar perfiles
				fetchOnvifMediaProfiles(this.$axios, baseURL, bodyConnection).then( resProfiles => {
						const root = resProfiles && resProfiles.data ? resProfiles.data : null;
						
						// Verificar si es el nuevo formato con array de perfiles
						if (root && root.profiles && Array.isArray(root.profiles) && root.profiles.length > 1) {
							// Nuevo formato: múltiples perfiles - mostrar tabla de selección
							this.profiles_list = root.profiles.map(p => ({
								id: p.id || p.token || '',
								channel: p.channel || null,
								main: p.main || {},
								sub: p.sub || null,
								hasPtz: p.hasPtz || false,
								profile: p
							}));
							this.pending_body_connection = bodyConnection;
							this.loading_onvif = false;
							this.dialog_profiles = true;
							return Promise.reject({ isProfileSelection: true });
						}
						
						const norm = this._extractProfileTokens(resProfiles);
						videoParamsByToken = this._extractProfileVideoParams(resProfiles);
						if (this.$Debug && this.$Debug.logs) {
							console.log('Profiles parsed:', norm, resProfiles && resProfiles.data);
						}
						if (norm.length === 0) {
							throw new Error('No profile tokens');
						}
						
						// Si solo hay un perfil o formato antiguo, usar el primero
						let selectedProfile = null;
						if (root && root.profiles && Array.isArray(root.profiles) && root.profiles.length === 1) {
							selectedProfile = root.profiles[0];
						}
						
						// Elegir dos tokens (main y sub si existen)
						if (selectedProfile) {
							// Nuevo formato con un solo perfil
							token1 = selectedProfile.main && selectedProfile.main.token ? selectedProfile.main.token : (selectedProfile.id || selectedProfile.token);
							// Si sub es null, copiar el token del main
							token2 = (selectedProfile.sub && selectedProfile.sub.token) ? selectedProfile.sub.token : token1;
						} else {
							// Formato antiguo
							token1 = norm[0] && norm[0].token;
							token2 = norm[1] && norm[1].token;
						}
						
						console.log('[ONVIF] Parsed profiles tokens:', { token1, token2, norm });
						
						// Si el nuevo formato tiene RTSP directamente, usarlo
						if (selectedProfile && selectedProfile.main && selectedProfile.main.rtsp) {
							return this._processSelectedProfile(selectedProfile, bodyConnection, username, password)
								.then(() => Promise.reject({ isProcessed: true }));
						}

						const req1 = this.$axios.post(baseURL + '/api/v1/onvif/media/stream-uri', {
							...bodyConnection,
							profileToken : token1,
							protocol     : 'RTSP',
						});
						const req2 = token2 ? this.$axios.post(baseURL + '/api/v1/onvif/media/stream-uri', {
							...bodyConnection,
							profileToken : token2,
							protocol     : 'RTSP',
						}) : Promise.resolve({ data: null });

						return Promise.all([req1, req2]);
					}).then( results => {
						// Validar que results existe y es un array
						if (!results || !Array.isArray(results)) {
							console.warn('[ONVIF] Invalid results format:', results);
							return;
						}
						console.log('[ONVIF] Stream-URI raw responses:', results);
						const extractUri = (r) => {
							if (!r || !r.data) return '';
							const d = r.data;
							// Intentar propiedades planas primero
							let uri =
								d.uri ||
								d.url ||
								d.rtsp ||
								(d.data && (d.data.uri || d.data.url));
							// Revisar estructura anidada { stream: { converted|data ... } }
							if (!uri && d.stream) {
								const st = d.stream;
								// converted.Body.GetStreamUriResponse.MediaUri.Uri
								if (
									st.converted &&
									st.converted.Body &&
									st.converted.Body.GetStreamUriResponse &&
									st.converted.Body.GetStreamUriResponse.MediaUri &&
									st.converted.Body.GetStreamUriResponse.MediaUri.Uri
								) {
									uri = st.converted.Body.GetStreamUriResponse.MediaUri.Uri;
								} else if (
									st.data &&
									st.data.GetStreamUriResponse &&
									st.data.GetStreamUriResponse.MediaUri &&
									st.data.GetStreamUriResponse.MediaUri.Uri
								) {
									uri = st.data.GetStreamUriResponse.MediaUri.Uri;
								}
							}
							// Fallback genérico: buscar campo Uri dentro de data a mano
							if (!uri && d.data) {
								try {
									const stack = [d.data];
									while (stack.length) {
										const obj = stack.pop();
										if (!obj || typeof obj !== 'object') continue;
										if (Object.prototype.hasOwnProperty.call(obj, 'Uri')) {
											uri = obj.Uri;
											break;
										}
										Object.keys(obj).forEach((k) => {
											if (obj[k] && typeof obj[k] === 'object') stack.push(obj[k]);
										});
									}
								} catch (e) {
									// ignore
								}
							}
							// Decodificar entidades HTML (&amp;)
							if (uri && typeof uri === 'string' && uri.includes('&amp;')) {
								uri = uri.replace(/&amp;/g, '&');
							}
							return uri || '';
						};
						// Limpiar parámetros (?transportmode=..., &profile=..., etc.)
						const cleanRtsp = (uri) => {
							if (!uri) return '';
							const idx = uri.indexOf('?');
							return idx >= 0 ? uri.substring(0, idx) : uri;
						};
						let uri1 = cleanRtsp(extractUri(results[0]));
						let uri2 = cleanRtsp(extractUri(results[1] || results[0]));
						console.log('[ONVIF] Extracted URIs (clean):', { uri1, uri2 });

						const insertCreds = (uri) => {
							if (!uri) return '';
							if (uri.includes('@')) {
								// Si ya tiene credenciales, decodificar la parte de credenciales
								const match = uri.match(/^(rtsp:\/\/)([^@]+)@(.+)$/);
								if (match) {
									const [, protocol, creds, rest] = match;
									// Decodificar las credenciales para mostrar correctamente
									const decodedCreds = decodeURIComponent(creds);
									return `${protocol}${decodedCreds}@${rest}`;
								}
								return uri;
							}
							if (username && password && uri.startsWith('rtsp://')) {
								return uri.replace('rtsp://', `rtsp://${encodeURIComponent(username)}:${encodeURIComponent(password)}@`);
							}
							return uri;
						};

						uri1 = insertCreds(uri1);
						uri2 = insertCreds(uri2);
						console.log('[ONVIF] URIs with credentials (if applied):', { uri1, uri2 });

						// Setear en los campos channel1 (rtsp) y channel2 (rtsp2)
						const nextInfo = { 
							...this.inf.info, 
							rtsp  : uri1 || this.inf.info.rtsp || '', 
							rtsp2 : uri2 || uri1 || this.inf.info.rtsp2 || '' 
						};
						console.log('[ONVIF] nextInfo to set in form:', nextInfo);
						this.$set(this.action_to_field, 'info', nextInfo);
						this.disabled_register = false;

						this.loading_onvif = false;
						this.dialog_connection = false;
						const formatMeta = (meta) => {
							if (!meta) return '';
							const parts = [];
							if (meta.encoding) parts.push(`codec: ${meta.encoding}`);
							if (meta.width && meta.height) parts.push(`resolución: ${meta.width}x${meta.height}`);
							if (meta.fps) parts.push(`fps: ${meta.fps}`);
							if (meta.bitrateKbps) parts.push(`bitrate: ${meta.bitrateKbps} kbps`);
							return parts.join(', ');
						};
						const meta1 = formatMeta(videoParamsByToken && (videoParamsByToken[token1] || null));
						// Si token2 es igual a token1 (sub es null), usar la misma metadata del main
						let meta2 = (token2 === token1) ? meta1 : formatMeta(videoParamsByToken && (videoParamsByToken[token2] || null));
						// Fallback: if sub-profile metadata is missing, reuse main profile meta
						if (!meta2 && meta1) {
							console.log('[ONVIF] Missing metadata for token2; falling back to token1 meta');
							meta2 = meta1;
						}
						// persist meta near the RTSP fields
						const withMetaInfo = { 
							...nextInfo,
							rtsp_meta  : meta1 || '',
							rtsp2_meta : meta2 || ''
						};
						console.log('[ONVIF] Setting metas into form info:', withMetaInfo);
						this.$set(this.action_to_field, 'info', withMetaInfo);
						// compute if register should stay disabled based on required fields
						try {
							const ready = this.check_rtsp(withMetaInfo.rtsp) && withMetaInfo.name && this.check_name(withMetaInfo.name);
							this.disabled_register = !ready;
						} catch(e) {
							// fallback: require at least rtsp present
							this.disabled_register = !(withMetaInfo && withMetaInfo.rtsp);
						}
						console.log('[ONVIF] Mapped video metadata to streams:', {
							token1,
							token2,
							rtsp1: withMetaInfo.rtsp,
							rtsp2: withMetaInfo.rtsp2,
							params1: videoParamsByToken ? videoParamsByToken[token1] : null,
							params2: videoParamsByToken ? videoParamsByToken[token2] : null
						});
						Eventbus.$emit('notifications_modal', {
							type: 'connection',
							message: `ONVIF Connected: ch1=${withMetaInfo.rtsp}${meta1 ? ' ('+meta1+')' : ''} ch2=${withMetaInfo.rtsp2}${meta2 ? ' ('+meta2+')' : ''}`
						})
					}).catch( er => {
						if (er && er.isProfileSelection) {
							// Es la selección de perfiles, no un error real
							return;
						}
						if (er && er.isProcessed) {
							// Ya se procesó el perfil con RTSP directo, no es un error
							return;
						}
						this.loading_onvif = false;
						
						// Extraer mensaje de error más descriptivo
						let errorMsg = msg; // 'Connection Fail' por defecto
						if (er && er.response && er.response.data) {
							const data = er.response.data;
							if (data.error) {
								errorMsg = data.error;
							} else if (data.message) {
								errorMsg = data.message;
							} else if (data.msg) {
								errorMsg = data.msg;
							} else if (typeof data === 'string') {
								errorMsg = data;
							}
						} else if (er && er.message) {
							errorMsg = er.message;
						}
						
						Eventbus.$emit('notifications_modal', {
							type: 'error',
							message: errorMsg
						})
						console.warn('ONVIF connection error', er);
					});
					
					// this.dialog_connection = false;
					// console.log("connection onvif");
				}
			}, // actions
			get_list(){
				const api = this.$URL + '/api/v1/onvif/discover';
				
				axios.defaults.withCredentials = false;
				this.loading_discover = true;
				axios.get(api).then( res => {
					// Normalizar respuesta del discover:
					// { devices: [{ name, xaddrs: [urls], types: [...] }, ...] }
					const devices = res && res.data && res.data.devices ? res.data.devices : [];
					const items = devices.map((d, idx) => {
						const name   = d && d.name ? decodeURIComponent(d.name) : '';
						const xaddrs = Array.isArray(d && d.xaddrs) ? d.xaddrs : [];
						// Tomar IP preferentemente IPv4
						let ip = '';
						if (xaddrs.length > 0) {
							const pick = xaddrs.find(u => u && u.indexOf('[') === -1) || xaddrs[0];
							try {
								ip = new URL(pick).hostname || '';
							} catch (e) {
								ip = '';
							}
						}
						return { index: idx, name, ip, xaddrs, types: Array.isArray(d && d.types) ? d.types : [] };
					});
					this.total = items.length;
					this.list  = items;
				}).catch( er => {
					console.log(er, 'Error get_list');
				}).finally(() => {
					this.loading_discover = false;
				})


			}, // get list

			save(){

				
				if (!this.$store.getters["auth/permission"]("device", "can_add", "device") ) {
					this.$EventBus.$emit("notifications_modal",{
						type 		: "warning",
						message 	: this.$ml.get("no_have_permission_create") + ' : ' + this.$ml.get("device"),
					});
					this.action_to_field.action = '1';					
					return false
				}

				let temp 	= this.inf.info;
				// console.log("save ", temp)
				let info_up = this.$Helper.format_req(temp, this.list_builder);
				if (temp.capacity && temp.limit) {
					info_up.limit = this.$Helper.convert_capacity(temp.capacity, temp.limit, 'string');

				}			
				info_up.is_motion = !info_up.is_motion;

				if (this.$is_docker) {
					let temp_name = location.hostname.split(".");
					temp_name     = temp_name[0] + '-' + info_up.name;
					info_up.name  = temp_name.trim();					
				}


				if (this.check_rtsp(info_up.rtsp) && info_up.name && this.check_name(info_up.name)) {				// 	
					if (info_up.name) {
						info_up.name = info_up.name.split(' ').join('_');
					}
					if (info_up.rtsp.indexOf(" ") > -1) {
						info_up.rtsp = info_up.rtsp.split(' ').join('');	
					}
					if (info_up.rtsp2 && info_up.rtsp2.indexOf(" ") > -1) {
						info_up.rtsp2 = info_up.rtsp2.split(' ').join('');
					}else{
						info_up.rtsp2 = info_up.rtsp;
					}

					info_up.type = "IP_CAM";
					this.loading_register = true;		

					const api = this.$URL + '/api/v1/device';

					// Init installation
					Eventbus.$emit('logs_install_image', info_up); // start_installation_progress
					// 
					this.$axios.post(api, info_up).then( res => {
						console.log(res.data, 'res device')
						this.action_to_field.action = '1';

						// Notification
						/*Eventbus.$emit('notifications_modal', {
							type: 'saved'
						});*/
						const inf_setting = res.data;
						localStorage.setItem('settings_device', JSON.stringify({ inf_setting }) );

						
						this.$store.commit("Devices/concat_devices", res.data);
						// Change sidebar and active motion
						/*this.$EventBus.$emit('render_modules', {
							name: 'new_device',
							associate: inf_setting,
						});*/
						// this.get_list();

						// Change route
						let vm = this;
						const timer = setTimeout( () =>{
							this.loading_register = false;
							// vm.$router.push();
							Eventbus.$emit('redirect_view', 'setting_device');
							clearTimeout(timer)
						}, 3000)
					}).catch( er => {
						this.action_to_field.action = '1';
						Eventbus.$emit('notifications_modal', {
							type: 'error'
						});
						this.loading_register = false;
						console.log(er, 'Error save')
					}) 

				}else{
					let msg = '';
					this.action_to_field.action = '1';
					if (!this.check_rtsp(info_up.rtsp)) {
						msg += this.$ml.get('rtsp') + ' : '+ this.$ml.get('no_valid');
					}
					if (!info_up.name) {
						msg += msg ? ', ' : '';  
						msg += this.$ml.get('required') + ' : ' + this.$ml.get('name');
					}
					if (!this.check_name(info_up.name)) {
						msg += msg ? ', ' : '';  
						msg += this.$ml.get('required') + ' : ' + this.$ml.get('valid_name_without_cs');
						
					}
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : msg
					});
				}
			}, // save

			update(){
				// console.log('step 5, save');
				let info_up = this.inf.info;
				// console.log('info to save', info_up);
				const api 	= this.$URL + '/api/v1/device';
				

				axios.defaults.withCredentials = false;
				axios.post(api, info_up).then( res => {
					console.log(res.data, 'res device')
						this.action_to_field.action = '1';
					Eventbus.$emit('notifications_modal', 'saved');
					this.get_list();
				}).catch( er => {
					Eventbus.$emit('notifications_modal', 'error');
					console.log(er, 'Error save')
				}) 
			}, // update
			// https://stackoverflow.com/questions/42199956/how-to-implement-debounce-in-vue2/53486112#53486112
			debounce_input(){
				debounce(function (newVal) {
			        this.debouncedInput = newVal
			      }, 500)
			}, // debounce input

			check_rtsp(str_url){
				//rtsp:\/\/\w{1,20}:\w{1,20}@\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3} // no work
				//for multiple checks
				/*"^((https|http|ftp|rtsp|mms)?://)" 
				   + "([0-9a-z_! *'(), &=+$%-]+:)?" [0-9a-z_! *'(), =+$%-]+ *)?"//ftp user?" "@ 
				      + "(([0-9] {1,3}){3} [0-9] {1,3}"// IP form URL - 199.194.52.184 
				      + "|"// Allow IP and DOMAIN (domain name)
				      + "([0-9a-z_! *'()-]+_)*"//domain name - www. 
				      + "([0-9a-z] [0-9a-z-]{0,61})? [0-9a-z]"//secondary domain name 
				      + "[a-z]{2,6})" // first level domain- .com or .museum 
				      + "(: [0-9] {1,4})?"//Port-:80 
				      + "((/?)|" // a slash isn't required if there is no file name 
				      + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";*/

				let strRegex = `(rtsp):\/\/([^\s@/]+)@([^\s/:]+)(?::([0-9]+))?(\/.*)` ;
				let strRegex1 = `rtsp:\/\/\w{1,20}:\w{1,20}@\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3`;
				let strRegex2 =  "(https?|rtsp|qvmc|rtmp):\\/\\/(?:([^\\s@\\/]+?)[@])?([^\\s\\/:]+)(?:[:]([0-9]+))?(?:(\\/[^\\s?#]+)([?][^\\s#]+)?)?([#]\\S*)?";
				// "(https?|rtsp|qvmc|rtmp):\/\/(?:([^\s@\/]+?)[@])?([^\s\/:]+)(?:[:]([0-9]+))?(?:(\/[^\s?#]+)([?][^\s#]+)?)?([#]\S*)?";
					let re  = new RegExp(strRegex);
					let re1 = new RegExp(strRegex1);
					let re2 = new RegExp(strRegex2);
					/*//re.test()
					let check_valid = str_url.split(":");
					let check = true;
					if (check_valid[0] !== "rtsp") {
						check = false;
					}else{
						let temp = new RegExp(`[//]`);
						if (!temp.test(check_valid[0])) {
							check = false;
						}
					}*/
					
					// console.log(re.test(str_url) , re1.test(str_url));
					if (re.test(str_url) || re1.test(str_url) || re2.test(str_url)){
						return (true);
					}else{
						return (false);
					}
			}, // check rtsp

			check_name(item){
				let reg 	= new RegExp("[a-zA-Z0-9][a-zA-Z0-9_.-]");
				let reg1 	= /[`´~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
				let reg2  	= /[´ñ]/gi;
				let regAllowEmpty = /^[A-Za-z\d\s]*$/;
				/*if (item && item.length > 0) {
					for(let it of item){
						if (reg1.test(it)) {
							console.log("CHECK NAME ", it)

						}else{
							console.warn("check fail : ", it)
						}
					}
				}*/
				if ((reg.test(item) && reg1.test(item)) || regAllowEmpty.test(item + "\n") ) {
					return true;
				}
				return false;

			}, // check name
			
			closeProfileDialog(){
				this.dialog_profiles = false;
				this.loading_onvif = false;
				this.selected_profiles = [];
				this.profiles_list = [];
				this.pending_body_connection = null;
			},
			
			selectProfile(){
				if (!this.selected_profiles || this.selected_profiles.length === 0) {
					Eventbus.$emit('notifications_modal', {
						type: 'warning',
						message: this.$ml.get('select_profile')
					});
					return;
				}
				
				const selectedProfile = this.selected_profiles[0];
				const bodyConnection = this.pending_body_connection;
				const username = this.info_onvif && this.info_onvif.user ? this.info_onvif.user : '';
				const password = this.info_onvif && this.info_onvif.password ? this.info_onvif.password : '';
				
				this.dialog_profiles = false;
				this.loading_onvif = true;
				
				// Usar el objeto profile si existe, sino usar el objeto completo
				const profileToProcess = selectedProfile.profile || selectedProfile;
				this._processSelectedProfile(profileToProcess, bodyConnection, username, password);
			},
			
			_processSelectedProfile(selectedProfile, bodyConnection, username, password){
				const baseURL = this.$URL;
				
					// Si el perfil ya tiene RTSP directamente, usarlo
					if (selectedProfile.main && selectedProfile.main.rtsp) {
						let uri1 = selectedProfile.main.rtsp;
						// Si sub es null o no tiene rtsp, copiar toda la información del main
						let uri2 = (selectedProfile.sub && selectedProfile.sub.rtsp) ? selectedProfile.sub.rtsp : selectedProfile.main.rtsp;
					
					// Insertar credenciales si no están presentes o decodificar si ya existen
					const insertCreds = (uri) => {
						if (!uri) return '';
						if (uri.includes('@')) {
							// Si ya tiene credenciales, decodificar la parte de credenciales
							const match = uri.match(/^(rtsp:\/\/)([^@]+)@(.+)$/);
							if (match) {
								const [, protocol, creds, rest] = match;
								// Decodificar las credenciales para mostrar correctamente
								const decodedCreds = decodeURIComponent(creds);
								return `${protocol}${decodedCreds}@${rest}`;
							}
							return uri;
						}
						if (username && password && uri.startsWith('rtsp://')) {
							return uri.replace('rtsp://', `rtsp://${encodeURIComponent(username)}:${encodeURIComponent(password)}@`);
						}
						return uri;
					};
					
					uri1 = insertCreds(uri1);
					uri2 = insertCreds(uri2);
					
					const nextInfo = { 
						...this.inf.info, 
						rtsp  : uri1 || this.inf.info.rtsp || '', 
						rtsp2 : uri2 || this.inf.info.rtsp2 || '' 
					};
					
					this.$set(this.action_to_field, 'info', nextInfo);
					this.disabled_register = false;
					this.loading_onvif = false;
					this.dialog_connection = false;
					
					Eventbus.$emit('notifications_modal', {
						type: 'connection',
						message: `ONVIF Connected: ch1=${uri1} ch2=${uri2}`
					});
					
					try {
						const ready = this.check_rtsp(nextInfo.rtsp) && nextInfo.name && this.check_name(nextInfo.name);
						this.disabled_register = !ready;
					} catch(e) {
						this.disabled_register = !(nextInfo && nextInfo.rtsp);
					}
					
					return Promise.resolve();
				}
				
				// Si no tiene RTSP, obtenerlo del token
				const token1 = selectedProfile.main && selectedProfile.main.token ? selectedProfile.main.token : (selectedProfile.id || selectedProfile.token);
				// Si sub es null, copiar el token del main
				const token2 = (selectedProfile.sub && selectedProfile.sub.token) ? selectedProfile.sub.token : token1;
				
				const req1 = this.$axios.post(baseURL + '/api/v1/onvif/media/stream-uri', {
					...bodyConnection,
					profileToken : token1,
					protocol     : 'RTSP',
				});
				const req2 = token2 ? this.$axios.post(baseURL + '/api/v1/onvif/media/stream-uri', {
					...bodyConnection,
					profileToken : token2,
					protocol     : 'RTSP',
				}) : Promise.resolve({ data: null });

				return Promise.all([req1, req2]).then( results => {
					// Validar que results existe y es un array
					if (!results || !Array.isArray(results)) {
						console.warn('[ONVIF] Invalid results format in _processSelectedProfile:', results);
						return;
					}
					console.log('[ONVIF] Stream-URI raw responses:', results);
					const extractUri = (r) => {
						if (!r || !r.data) return '';
						const d = r.data;
						let uri =
							d.uri ||
							d.url ||
							d.rtsp ||
							(d.data && (d.data.uri || d.data.url));
						if (!uri && d.stream) {
							const st = d.stream;
							if (
								st.converted &&
								st.converted.Body &&
								st.converted.Body.GetStreamUriResponse &&
								st.converted.Body.GetStreamUriResponse.MediaUri &&
								st.converted.Body.GetStreamUriResponse.MediaUri.Uri
							) {
								uri = st.converted.Body.GetStreamUriResponse.MediaUri.Uri;
							} else if (
								st.data &&
								st.data.GetStreamUriResponse &&
								st.data.GetStreamUriResponse.MediaUri &&
								st.data.GetStreamUriResponse.MediaUri.Uri
							) {
								uri = st.data.GetStreamUriResponse.MediaUri.Uri;
							}
						}
						if (!uri && d.data) {
							try {
								const stack = [d.data];
								while (stack.length) {
									const obj = stack.pop();
									if (!obj || typeof obj !== 'object') continue;
									if (Object.prototype.hasOwnProperty.call(obj, 'Uri')) {
										uri = obj.Uri;
										break;
									}
									Object.keys(obj).forEach((k) => {
										if (obj[k] && typeof obj[k] === 'object') stack.push(obj[k]);
									});
								}
							} catch (e) {
								// ignore
							}
						}
						if (uri && typeof uri === 'string' && uri.includes('&amp;')) {
							uri = uri.replace(/&amp;/g, '&');
						}
						return uri || '';
					};
					const cleanRtsp = (uri) => {
						if (!uri) return '';
						const idx = uri.indexOf('?');
						return idx >= 0 ? uri.substring(0, idx) : uri;
					};
					let uri1 = cleanRtsp(extractUri(results[0]));
					let uri2 = cleanRtsp(extractUri(results[1] || results[0]));

					const insertCreds = (uri) => {
						if (!uri) return '';
						if (uri.includes('@')) {
							// Si ya tiene credenciales, decodificar la parte de credenciales
							const match = uri.match(/^(rtsp:\/\/)([^@]+)@(.+)$/);
							if (match) {
								const [, protocol, creds, rest] = match;
								// Decodificar las credenciales para mostrar correctamente
								const decodedCreds = decodeURIComponent(creds);
								return `${protocol}${decodedCreds}@${rest}`;
							}
							return uri;
						}
						if (username && password && uri.startsWith('rtsp://')) {
							return uri.replace('rtsp://', `rtsp://${encodeURIComponent(username)}:${encodeURIComponent(password)}@`);
						}
						return uri;
					};
					
					uri1 = insertCreds(uri1);
					uri2 = insertCreds(uri2);
					
					const nextInfo = { 
						...this.inf.info, 
						rtsp  : uri1 || this.inf.info.rtsp || '', 
						rtsp2 : uri2 || uri1 || this.inf.info.rtsp2 || '' 
					};
					
					this.$set(this.action_to_field, 'info', nextInfo);
					this.disabled_register = false;
					this.loading_onvif = false;
					this.dialog_connection = false;
					
					Eventbus.$emit('notifications_modal', {
						type: 'connection',
						message: `ONVIF Connected: ch1=${uri1} ch2=${uri2}`
					});
					
					try {
						const ready = this.check_rtsp(nextInfo.rtsp) && nextInfo.name && this.check_name(nextInfo.name);
						this.disabled_register = !ready;
					} catch(e) {
						this.disabled_register = !(nextInfo && nextInfo.rtsp);
					}
				}).catch( er => {
					this.loading_onvif = false;
					Eventbus.$emit('notifications_modal', {
						type: 'error',
						message: this.$ml.get('error_get_stream_uri') || this.$ml.get('error')
					});
					console.warn('ONVIF stream-uri error', er);
				});
			},


			
		}, // methods
		computed: {
			render_list: function(){
				const term = (this.search_discover || '').toLowerCase().trim();
				if (!term) {
					return this.list;
				}
				return this.list.filter(item => {
					const name = (item && item.name ? String(item.name) : '').toLowerCase();
					const ip   = (item && item.ip ? String(item.ip) : '').toLowerCase();
					return name.includes(term) || ip.includes(term);
				});
			},
		}, // computed

		mounted(){
			/*let regAllowEmpty = /^[A-Za-z\d\s]*$/;
			let reg 	= new RegExp("[a-zA-Z0-9][a-zA-Z0-9_.-]");
			let reg1 	= /[`´~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;

			["", "Adam", "Ada m", "A1dam", "A!dam", 'sdasd 213123&*&*&', 'sd_asd'].forEach(function (str) {
			    console.log( "test", str, regAllowEmpty.test(str + "\n") , reg.test(str), reg1.test(str));
			}); */
			// Eventbus.$on('connection_new_device', (action) =>{
				
			// })
		}, // mounted

		beforeDestroy(){
			// Limpiar timer al destruir el componente
			if (this.rtsp2_preview_timer) {
				clearTimeout(this.rtsp2_preview_timer);
				this.rtsp2_preview_timer = null;
			}
		}, // beforeDestroy
	};
</script>
